
import React from 'react';
import FeaturedBlog from '@/components/blog/FeaturedBlog';
import BlogList from '@/components/blog/BlogList';

const Blog: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col pt-16">
      {/* Simple Hero Section */}
      <div className="bg-white py-12 md:py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-navy mb-4">
            Blog de Migrante Amigo
          </h1>
          <p className="text-lg text-coolGray max-w-2xl mx-auto">
            Noticias, consejos y actualizaciones sobre inmigración.
          </p>
        </div>
      </div>
      
      <div className="container mx-auto px-4 py-12">
        <FeaturedBlog />
        
        <h2 className="text-2xl md:text-3xl font-bold text-navy mb-8">Artículos Recientes</h2>
        
        <BlogList />
      </div>
    </div>
  );
};

export default Blog;
